import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import framework from 'utils/framework';
import { itemsSelector } from 'selectors/page/headerFooterTemplate/data/megaNav/items/itemsSelector';
import { p13nSelector } from 'selectors/p13n/p13nSelector';
import { coreUserDataSelector } from 'viewModel/selectors/user/coreUserDataSelector';
import { megaNavSelector } from 'selectors/page/headerFooterTemplate/data/megaNav/megaNavSelector';
import Personalization from 'utils/Personalization';
import Empty from 'constants/empty';

const { getMegaNavPersonalizedComponent } = Personalization;

const { wrapHOC } = framework;

const fields = createSelector(itemsSelector, p13nSelector, coreUserDataSelector, megaNavSelector, (items, p13n, user, megaNavData) => {
    let personalizedComponent = Empty.Array;

    if (!Sephora.isNodeRender && Sephora.Util.InflatorComps.services.loadEvents.HydrationFinished) {
        personalizedComponent = getMegaNavPersonalizedComponent(p13n, megaNavData.personalization, user);
    }

    const navItems = (!user.isAnonymous && personalizedComponent?.variationData?.items) || items || Empty.Array;

    const menuItems = [...navItems];

    return {
        menuItems
    };
});

const withNavigationMenu = wrapHOC(connect(fields));

export {
    fields, withNavigationMenu
};
